import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { emptyPageShows, incrementPageShows } from "../Redux/Shows/ShowsSlice";
import { FetchShowsthunk } from "../Redux/Shows/ShowsAction";
import { useTranslate } from "../components/TranslationText";
import SubmitBtn from "../components/SubmitBtn";
import Loader from "../components/Loader";
import ShowsFilter from "../components/ShowsFilter";
import { convertToCamelCase } from "../helper/convertToCamelCase";
import ComingSoon from "../components/ComingSoon";
import FilterButton from "../components/FilterButton";
import { formatDate } from "../helper/formatDate";
import ShowCard from "../components/ShowCard";
import NewActionButton from "../components/ActionButtons/NewActionButton";
import { filterResponsive, rightResponsive } from "../common/cssclasses";
import { updateHeadTags } from "../helper/updateHeadTags";
import axiosUmbraco from "../axios/axiosUmbraco";
const showId = process.env.REACT_APP_UMBRACO_SHOWS_PAGE_SEO;

export default function Shows() {
  const BaseURL = process.env.REACT_APP_BASE_URL;
  const [showFilter, setShowFilter] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isHovered, setIsHovered] = useState(false);
  const dispatch = useDispatch();
  const { currentLanguage } = useSelector((state) => state.studBookSlice);
  const { translate } = useTranslate();
  const [selectedTab, setSelectedTab] = useState(1);

  const {
    showsData,
    pageShows,
    takeShows,
    totalCountShows,
    stateShowMoreButtonHorse,
    showsLoading,
  } = useSelector((state) => state.showsSlice);

  const [filterCriteria, setFilterCriteria] = useState({
    search: null,
    year: "",
    month: "",
    country: null,
    showStatus: [],
  });

  useEffect(() => {
    if (pageShows === 0) {
      dispatch(emptyPageShows());
      return;
    }

    let params = {
      skip: (pageShows - 1) * takeShows,
      take: takeShows,
      langauge: currentLanguage,
      showName: filterCriteria.search,
      year: filterCriteria.year === "" ? null : filterCriteria.year,
      month: filterCriteria.month === "" ? null : filterCriteria.month,
      emirateId: filterCriteria.country,
      showStatus: filterCriteria.showStatus,
    };
    dispatch(FetchShowsthunk(params));
  }, [pageShows, filterCriteria, currentLanguage]);

  const updateShowsList = (newFilters) => {
    dispatch(emptyPageShows());
    setFilterCriteria({ ...newFilters, showStatus: selectedTab == 1 ? ['Upcoming', 'Ongoing'] : ['Past'] });
  };

  const handelShowMore = async () => {
    dispatch(incrementPageShows());
  };

  const handleMouseOver = () => {
    setIsHovered(true);
  };

  const handleMouseOut = () => {
    setIsHovered(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleFilter = () => {
    setShowFilter(!showFilter);
  };

  async function getSeo() {
    const seo = await axiosUmbraco.get(`/umbraco/delivery/api/v1/content/item/?id=${showId}`,);
    if (seo?.data?.length > 0) {
      const seoData = seo.data[0].properties;
      updateHeadTags({
        keywords: seoData?.seoKeywords,
        description: seoData?.seoDescription,
        title: seoData?.seoTitle,
      })
    }
  }
  useEffect(() => {
    getSeo();
  }, [])
  useEffect(() => {
    if (selectedTab == 1) {
      updateShowsList({ ...filterCriteria, showStatus: ['Upcoming', 'Ongoing'] });
      // Past
    } else {
      updateShowsList({ ...filterCriteria, showStatus: ['Past'] });
    }

  }, [selectedTab])

  return (
    <>
      {
        // loading div
      }
      <div
        className={`page-overlay text-center ${showsLoading ? "classdisplay" : "classnotdisplay"
          }`}
      >
        <div className="loaderDiv">
          <Loader />
        </div>
      </div>

      <div className="row rtl">
        {windowWidth < 768 && (
          <div className="col-md-4 col-sm-6 col-6 text-center d-flex justify-content-center mb-3 mx-auto">
            <FilterButton onClick={toggleFilter} />
          </div>
        )}
        {
          // Shows Filter div
        }
        <div
          className={filterResponsive}
          style={{
            display:
              windowWidth >= 768 ? "block" : showFilter ? "block" : "none",
          }}
        >
          <ShowsFilter onSubmit={updateShowsList} />
        </div>


        <div className={rightResponsive}>
          <div className="row" >
            <div
              className={'col-sm-6 col-6 pe-0 mb-main text-center'}
              id="second_most_used_services"
              style={{ cursor: 'pointer' }}
              onClick={() => setSelectedTab(1)}
            >
              <span className={`${selectedTab == 1 ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 20 }}>{translate("web.runningAndUpcoming", "Running And Upcoming")}</span>
              <div className="service_bar_underline" style={selectedTab == 1 ? { border: '3px solid #e44d52', marginTop: 16 } : {}}></div>
            </div>
            <div
              className={'col-sm-6 col-6 ps-0 mb-main text-center '}
              id="second_registration_services"
              style={{ cursor: 'pointer' }}
              onClick={() => setSelectedTab(2)}
            >
              <span className={`${selectedTab == 2 ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 20 }}>{translate("web.pastEvents", "Past")}</span>
              <div className="service_bar_underline" style={selectedTab == 2 ? { border: '3px solid #e44d52', marginTop: 16 } : {}}></div>
            </div>
          </div>
          {/* <div className="row m0responsive"> */}
          <div className="row">

            {!!showsData && showsData.length > 0 ? <>
              {showsData.map((item, i) => (
                <ShowCard key={i} i={i} item={item} />
              ))}
            </> : <>
              <div className="col-md-12 col-sm-12  text-danger text-center">                
                <h2>{translate("web.nodataFound", "No Data Found")}</h2>
              </div>
            </>}
          </div>
        </div>

        <div className="col-md-3 col-sm-12"></div>
        {
          // Show More div
        }
        <div className="col-lg-9 col-md-12 col-sm-12 row text-center">
          {!showsLoading && !!showsData && showsData.length > 0 ? (
            <div className="mx-auto w-unset">
              <NewActionButton
                isButton
                disabled={stateShowMoreButtonHorse}
                onClick={handelShowMore}
                text={`
                  ${translate("web.showMore", "Show More")} (${showsData.length
                  } ${translate("web.of", "Of")} ${totalCountShows})`}
              />
            </div>
          ) : (
            ""
          )}
          {showsLoading && <Loader />}
        </div>

      </div>
    </>
    // <ComingSoon />
  );
}
